/**
 * Query param carrying a Descope embedded-link token on the legacy preferences
 * email (ENG-3878). Links minted this way stay live for 7 days, so the page keeps
 * honouring it after messaging switches to {@link PREFERENCES_LINK_TOKEN_PARAM}.
 */
export const PREFERENCES_TOKEN_PARAM = 'token';

/**
 * Query param carrying the messaging-signed preferences link token (ENG-4935).
 * The page trades it at the gateway for a Descope token before verifying.
 *
 * Mirrors the constant messaging-service builds the link from in
 * `@zencity/platform-sdk`; this repo does not depend on the SDK, so a rename
 * there must be repeated here or every emailed link breaks.
 */
export const PREFERENCES_LINK_TOKEN_PARAM = 'plt';

/** Every param that carries a credential and must leave the address bar. */
export const PREFERENCES_TOKEN_PARAMS = [PREFERENCES_LINK_TOKEN_PARAM, PREFERENCES_TOKEN_PARAM];

/**
 * Shared prefix so every step of the emailed-link flow can be pulled up with a
 * single Datadog query (`@context.flow:preferences-token-exchange`).
 *
 * Note the browser SDKs are initialised with sessionSampleRate: 5, so only ~5%
 * of sessions report. When chasing one specific link, reproduce until a session
 * is sampled, or raise the rate temporarily.
 */
export const PREFERENCES_EXCHANGE_LOG_FLOW = 'preferences-token-exchange';
